import React, { memo, useEffect } from "react";
import { Button, makeStyles } from "@material-ui/core";
import { ContactoContratacionesModal } from "./ContactoContratacionesModal";
import { ContactoContratacionesItem } from "./ContactoContratacionesItem";
import { useSelector, useDispatch } from "react-redux";
import {
  getContactosEfector,
  setOpenCreateEditModal,
  setearContactoEditDelete,
  getTiposContactoEfectores,
  getObservacionesContactosEfector,
} from "../../../actions/contrataciones/contratacionesContactos";
import moment from "moment";
import "moment/locale/es";
import { MENU_CONTRATACIONES } from "../../../utils/constants";
import ObservacionesContactos from "./ObservacionesContactos";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    flex: 1,
    marginBottom: 15,
    display: "flex",
    justifyContent: "flex-end",
  }
}));

export const ContactosContrataciones = memo((props) => {
  const dispatch = useDispatch();
  moment.locale("es");
  const classes = useStyles();

  const { tipoContacto, contactos, openCreateEditModal } = useSelector((state) => state.contratacionesContactos);

  const { idEfectorFacturacion } = props;

  const disabled = props.menu === MENU_CONTRATACIONES.CONSULTA;

  useEffect(() => {
    dispatch(getTiposContactoEfectores());
    dispatch(getContactosEfector(idEfectorFacturacion));
    dispatch(getObservacionesContactosEfector());
  }, [dispatch, idEfectorFacturacion]);

  const handleCloseModal = () => {
    dispatch(setOpenCreateEditModal(false));
  };

  const handleOpenModal = () => {
    dispatch(setearContactoEditDelete(null));
    dispatch(setOpenCreateEditModal(true));
  };

  return (
    <>
      {!disabled &&
        <div className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleOpenModal}
          >
            + Agregar Contacto
          </Button>
        </div>
      } 
      <div className={classes.buttonContainer}>
        <ObservacionesContactos disabled={disabled} />
      </div>
      <ContactoContratacionesItem contactos={contactos} disabled={disabled} />
      <ContactoContratacionesModal
        className={classes.modalContacto}
        tipoContacto={tipoContacto}
        open={openCreateEditModal}
        handleClose={handleCloseModal}
      />
    </>
  );
});
